(ns ycweb.app.blitz.packing.packer.area
  (:require
   [rum.core :as rum]
   [util.string :as utilstr]
   [ycweb.components.common :as cmn]
   [ycweb.components.grid :as grid]
   [ycweb.components.transitions :as t]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.wrapper :as w]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]))

(defn slat-colour [colour]
  (case colour
    "red"
    [:red :red-bg]

    "blue"
    [:blue :blue-bg]

    "green"
    [:green :green-bg]

    "red-green"
    [:red-green :neutral-bg]

    "grey"
    [:neutral :neutral-bg]

    [:neutral :neutral-bg]))

(rum/defc packing-type-slat < rum/reactive
  [{:keys [display-name colour alloc-count]} {:keys [on-click]}]
  (let [[slat-color slat-bg-color] (slat-colour colour)]
    [:article.slat-wrapper
     [:div.picking-slat
      {:class (u/bem :slat [slat-color slat-bg-color]) :on-click on-click}
      [:div.picking-slat__graphic-wrapper
       [:span.picking-slat__icon-wrapper
        [:span.picking-slat__size-text (utilstr/upper-case (first display-name))]]]
      [:div.picking-slat__info
       [:h3.pickin-slat__title
        (str display-name " (Orders: " alloc-count ")")]]]]))

(rum/defc landing-screen < rum/reactive [app-atom steps]
  (let [packing-atom (rum/cursor app-atom :packing)
        areas (cmn/curact packing-atom :areas)]
    (w/wrapper app-atom "Packing"
      {:steps steps :step :packing-area}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard :flush])}
         "Select a Packing Area"]]
       (into
         [:div.slats]
         (map
           (fn [area]
             (packing-type-slat
               {:display-name (:displayname area)
                :alloc-count (:number-of-orders area)
                :colour (:colour area)}
               {:on-click
                #(grid/dispatch-action app-atom :packing/select-packing-area
                   {:packing-area (:displayname area)})}))
           areas))]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-plain true}))))

(defmethod grid/action :packing/select-packing-area [app-atom {:keys [packing-area]}]
  (let [packing-atom (rum/cursor app-atom :packing)]
    (swap! packing-atom assoc :area packing-area)
    (t/transition-next app-atom :packing/location-scan)))

